import React from "react";
import Link from "next/link";
import Head from "next/head";
import "bulma/css/bulma.min.css";
import AppFooter from "../shared/AppFooter";
import PageHeader from "../shared/PageHeader";

export default ({ children, title = "Serviço de Videoconferências - UFFS" }) => (
  <React.Fragment>
    <Head>
      <title>{title}</title>
      <script defer src="https://use.fontawesome.com/releases/v5.0.7/js/all.js"></script>
    </Head>

    <div className="main">
      <div className="content-wrapper">
        <PageHeader />

        {children}
      </div>

      <AppFooter />
    </div>

    <style jsx global>{`
      html, body, #__next {
        height: 100%;
      }

      .main {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .content-wrapper {
        flex: 1 0 auto;
      }
    `}</style>
  </React.Fragment>
);



// WEBPACK FOOTER //
// components/layouts/BaseLayout.js